import { useQueueChatPauseContext } from 'hooks/useQueuePauseChatServicePanel';
import React from 'react';
import { InputGroupAddon } from 'reactstrap';
import { useClickToCallOnPhoneField } from '../../hooks/useClickToCallOnPhoneField';
import { agentIsPausedOrLoggedOut } from 'views/shared/helpers/checkIfAgentOnPauseOrLogouf';
import { IoChatbubble } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { ActionInputButton } from 'components/FlexControllerInput/components/styles';

export const InputWithButtonWhatsapp = ({
  phoneValue,
  phoneDDI,
  handleWhatsAppMessage
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const { messageSendingBlocked } = useQueueChatPauseContext();
  const { canSendMessage } = useClickToCallOnPhoneField();
  return (
    <InputGroupAddon addonType="append">
      <ActionInputButton
        primaryColor={systemConfiguration.primary_color}
        disabled={!canSendMessage(phoneValue, phoneDDI)}
        onClick={() => {
          if (agentIsPausedOrLoggedOut(messageSendingBlocked)) return;
          handleWhatsAppMessage({ ddi: phoneDDI, number: phoneValue });
        }}
      >
        <IoChatbubble size={14} />
      </ActionInputButton>
    </InputGroupAddon>
  );
};
